var _mask, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnionNewP(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2560,
    height: 301,
    viewBox: "0 0 2560 301",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_3015_6563",
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 2562,
    height: 302,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -1,
    width: 2562,
    height: 302
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2560 29H1373C1342.04 29 1327.86 20.3796 1315.24 12.7051C1305.11 6.54817 1295.99 1 1280 1C1264.01 1 1254.88 6.54868 1244.76 12.7059C1232.14 20.3803 1217.96 29 1187 29H0V301H2560V29Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2560 29H1373C1342.04 29 1327.86 20.3796 1315.24 12.7051C1305.11 6.54817 1295.99 1 1280 1C1264.01 1 1254.88 6.54868 1244.76 12.7059C1232.14 20.3803 1217.96 29 1187 29H0V301H2560V29Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2560 29H2561V28H2560V29ZM1315.24 12.7051L1315.76 11.8506V11.8506L1315.24 12.7051ZM1244.76 12.7059L1244.24 11.8515V11.8515L1244.76 12.7059ZM0 29V28H-1V29H0ZM0 301H-1V302H0V301ZM2560 301V302H2561V301H2560ZM1373 30H2560V28H1373V30ZM1314.72 13.5596C1321.03 17.3964 1327.81 21.5223 1336.91 24.6754C1346.02 27.8307 1357.42 30 1373 30V28C1357.62 28 1346.44 25.8592 1337.57 22.7856C1328.69 19.7098 1322.07 15.6884 1315.76 11.8506L1314.72 13.5596ZM1280 2C1295.69 2 1304.61 7.41535 1314.72 13.5596L1315.76 11.8506C1305.61 5.681 1296.28 0 1280 0V2ZM1245.28 13.5604C1255.38 7.41586 1264.3 2 1280 2V0C1263.71 0 1254.39 5.68149 1244.24 11.8515L1245.28 13.5604ZM1187 30C1202.58 30 1213.97 27.8308 1223.08 24.6758C1232.19 21.5229 1238.97 17.3971 1245.28 13.5604L1244.24 11.8515C1237.93 15.6891 1231.31 19.7104 1222.43 22.7859C1213.56 25.8593 1202.38 28 1187 28V30ZM0 30H1187V28H0V30ZM1 301V29H-1V301H1ZM2560 300H0V302H2560V300ZM2559 29V301H2561V29H2559Z",
    fill: "#EAE4E3",
    mask: "url(#path-1-outside-1_3015_6563)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionNewP);
export default __webpack_public_path__ + "static/media/unionNewP.cb6153ccf9d45390e26cd7a37c21ec9e.svg";
export { ForwardRef as ReactComponent };